<script lang="ts">
  import Notifications from "$app/Pages/Notifications/Index.svelte"
  import UserMenu from "./Menus/UserMenu.svelte"
  import PlanMenu from "./Menus/PlanMenu.svelte"
  import { Bell } from "lucide-svelte"
  import { appStore } from "$app/store.svelte"
  import logo from "@images/logo/logo_white_small.png"

  let { plans, plan, current_user } = $props()

  let show_notifications = $state(false)

  const hostname = location.hostname.substring(
    0,
    location.hostname.indexOf(".")
  )
</script>

<nav class="bg-lwp-accent shadow" id="main-nav">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 main-nav">
    <div class="relative flex items-center justify-between h-16">
      <div class="flex-1 flex items-center justify-start">
        <div class="flex-shrink-0 flex items-center">
          {#if current_user && plans.length === 1}
            <a href="/plans/{plans[0].id}">
              <img src={logo} class="h-12 w-auto" alt="Lead With Purpose" />
            </a>
          {:else if current_user && plans.length > 1}
            <a href="/plans">
              <img src={logo} class="h-12 w-auto" alt="Lead With Purpose" />
            </a>
          {:else if hostname !== "teams"}
            <a href="/">
              <img src={logo} class="h-12 w-auto" alt="Lead With Purpose" />
            </a>
          {:else}
            <img src={logo} class="h-12 w-auto" alt="Lead With Purpose" />
          {/if}
        </div>
      </div>
      <div
        class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0"
      >
        {#if current_user}
          <div
            class="ml-4 flex items-center justify-center gap-x-3"
            id="user-menu"
          >
            <div class="flex items-center justify-center">
              <PlanMenu {plans} {plan} plan_role={current_user.role} />
            </div>
            <button
              class="w-10 h-10 rounded-full bg-indigo-800 hover:bg-indigo-700 flex items-center justify-center relative mr-2"
              onclick={() => (show_notifications = !show_notifications)}
            >
              <Bell class="h-8 w-8 text-white" />
              {#if appStore.unread_notifications.length > 0}
                <span
                  class="absolute right-0 top-0 h-5 w-5 -translate-y-0.5 translate-x-2.5 transform rounded-full bg-red-600 ring-1 ring-red-200 text-white text-sm font-bold flex items-center justify-center"
                  >{appStore.unread_notifications.length}</span
                >
              {/if}
            </button>
            <div class="flex items-center justify-center">
              <UserMenu />
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
</nav>

<Notifications
  open={show_notifications}
  onclose={() => (show_notifications = false)}
/>
